import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { takeUntil, takeWhile } from 'rxjs/operators';
import { UnitService } from '../../helper/anessa-library/anessa-library/projects/unit-library/src/public-api';
import { UserpilotReloader } from '../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-project-input',
  templateUrl: './project-input.component.html',
  styleUrls: [
    './project-input.component.scss',
  ]
})
export class ProjectInputComponent extends UserpilotReloader implements OnInit {
  @Output() formDirty = new EventEmitter<boolean>();

  onDestroyNotifier = new EventEmitter<boolean>();

  unitsLoaded = false;

  constructor(
    private unitService: UnitService,
  ) {
    super();
  }

  ngOnInit() {
    this.unitService.unitsLoadedNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .pipe(takeWhile(x => !x, true))
      .subscribe(ready => {
        this.unitsLoaded = ready;
      });
    if (!this.unitService.unitsLoadedNotifier.value) {
      this.unitService.loadData();
    }
  }

  changesMade(val) {
    this.formDirty.emit(val);
  }
}
